export const InvoiceTypes = [
  { text: 'Email', value: 'EMAIL' },
  { text: 'EHF', value: 'EHF' },
  { text: 'eFaktura', value: 'EFAKTURA' },
  { text: 'e-Invoicing', value: 'SWEDISH_EINVOICING' }
];
export const PaymentResults = {
  NotPaid: { name: 'NOT_PAID', success: false },
  Paid: { name: 'PAID', success: true },
  CredentialsMissing: { name: 'CREDENTIALS_MISSING', success: false },
  CardRefused: { name: 'CARD_REFUSED', success: false },
  UnknownReason: { name: 'UNKNOWN_REASON', success: false },
  PaidFreeTransaction: { name: 'FREE_TRANSACTION', success: true },
  NoPaymentMethod: { name: 'NO_PAYMENT_METHOD', success: false }
};

export enum InvoiceSendMethod {
  EMAIL = 0,
  EHF = 1,
  EFAKTURA = 2,
  SWEDISH_EINVOICING = 10
}

export interface CountryInvoiceTypes {
  AllowedForCompanies: boolean;
  AllowedForPrivateIndividuals: boolean;
  FK_CountryID: number;
  InvoiceType: InvoiceSendMethod;
  Name: string;
}

export enum ExternalInvoiceType {
  SmartCharge = 0,
  Tripletex = 1,
  Moment = 2,
  Billecta = 3
}

export enum IntermediatorTypeView {
  ITELLA = 'ITELLA',
  TIETOSE = 'TIETOSE',
  LOGICA = 'LOGICA',
  PROCEEDO = 'PROCEEDO',
  HUSERA = 'HUSERA',
  BASWARE = 'BASWARE',
  EDB = 'EDB',
  STRALFORS1 = 'STRALFORS1',
  LIAISON_FI = 'LIAISON_FI',
  EXPERT = 'EXPERT',
  ESSESESS = 'ESSESESS',
  HANDSESS = 'HANDSESS',
  DABASESS = 'DABASESS',
  SWEDSESS = 'SWEDSESS',
  NDEASESS = 'NDEASESS',
  INEXCHANGE = 'INEXCHANGE',
  SCANCLOUD = 'SCANCLOUD',
  PAGERO = 'PAGERO',
  CREDIFLOW = 'CREDIFLOW',
  PEPPOL = 'PEPPOL',
  COMPELLO = 'COMPELLO',
  LOGIQ = 'LOGIQ',
  APIX = 'APIX',
  AKSESSPUNKT = 'AKSESSPUNKT',
  FININVOICE = 'FININVOICE',
  Unknown = 'Unknown'
}
//export const Intermediators:string[] = Object.keys(IntermediatorTypeView).filter(key=>isNaN(Number(key)));

export const Intermediators = [
  { name: 'Unknown', key: IntermediatorTypeView.Unknown },
  { name: 'Aksesspunkt Norge AS', key: IntermediatorTypeView.AKSESSPUNKT },
  { name: 'Apix Messaging AB', key: IntermediatorTypeView.APIX },
  { name: 'Basware', key: IntermediatorTypeView.BASWARE },
  { name: 'CGI', key: IntermediatorTypeView.LOGICA },
  { name: 'Compello', key: IntermediatorTypeView.COMPELLO },
  { name: 'Crediflow', key: IntermediatorTypeView.CREDIFLOW },
  { name: 'Danske bank', key: IntermediatorTypeView.DABASESS },
  { name: 'Evry', key: IntermediatorTypeView.EDB },
  { name: 'Finvoice', key: IntermediatorTypeView.FININVOICE },
  { name: 'Handelsbanken', key: IntermediatorTypeView.HANDSESS },
  { name: 'InExchange', key: IntermediatorTypeView.INEXCHANGE },
  { name: 'Liaison Technologies', key: IntermediatorTypeView.LIAISON_FI },
  { name: 'Logiq AS', key: IntermediatorTypeView.LOGIQ },
  { name: 'Nordea', key: IntermediatorTypeView.NDEASESS },
  { name: 'OpusCapita', key: IntermediatorTypeView.ITELLA },
  { name: 'Pagero', key: IntermediatorTypeView.PAGERO },
  { name: 'Palette', key: IntermediatorTypeView.HUSERA },
  { name: 'PEPPOL', key: IntermediatorTypeView.PEPPOL },
  { name: 'Readsoft/Lexmark', key: IntermediatorTypeView.EXPERT },
  { name: 'Scancloud', key: IntermediatorTypeView.SCANCLOUD },
  { name: 'SEB', key: IntermediatorTypeView.ESSESESS },
  { name: 'Strålfors Svenska AB', key: IntermediatorTypeView.STRALFORS1 },
  { name: 'Swedbank', key: IntermediatorTypeView.SWEDSESS },
  { name: 'Tieto', key: IntermediatorTypeView.TIETOSE },
  { name: 'Visma Proceedo AB', key: IntermediatorTypeView.PROCEEDO }
];
